// Query parameters used by Adblock Plus to work with Google Manifest V3
// https://godaddy-corp.atlassian.net/browse/PARKING-3287
export const abpParams = `abp=1&gdabp=true`;
export const abpParams2 = `abp=2&gdabp=true`;
